import { render, staticRenderFns } from "./TeacherCombo.vue?vue&type=template&id=1e5932cc"
import script from "./TeacherCombo.vue?vue&type=script&lang=js"
export * from "./TeacherCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports